import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Sombra = styled.div`
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
`;

export const SubContainer = styled.div`
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
`;

export const TitlePage = styled.h1`
  font-weight: 500;
  font-size: 48px;
  margin-bottom: 24px;
  text-align: center;
`;

export const ContCalendarTotal = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const ContCalendar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;

export const ContInfosTotal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 20px;
  width: 100%;
`;

export const ContCargaDesc = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  transition: 0.3s;
  box-shadow: 0 0 6px 1px #3c6ab4;

  background-color: rgba(255, 255, 255, 0.95);

  &:hover {
    -xpedu-transform: scale(1.02);
    -ms-transform: scale(1.02);
    transform: scale(1.02);
  }

  .infos {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    justify-content: space-evenly;
    gap: 10px;
  }

  .contGrap {
    max-height: 350px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 32px;
  color: #3c6ab4;
  font-weight: 500;
  letter-spacing: 0.5px;
`;

export const Toneladas = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #444;
`;

export const List = styled.ul`
  list-style: none;
  display: flex;
  align-items: flex-end;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  li {
    margin: 5px;
    padding: 2px;
    color: #444;
    font-weight: 700;
    letter-spacing: 0.5px;
    font-size: 0.875rem;

    div {
      font-weight: 700;
      font-size: 1rem;
      color: #222;
    }
  }
`;

export const ContCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Card = styled.div`
  background-color: rgba(255, 255, 255, 0.95);
  padding: 10px;
  margin: 10px;
  border-radius: 4px;
  margin: 10px;
  box-shadow: 0 0 6px 1px #3c6ab4;
  min-width: 380px;
  max-width: 400px;
  transition: 0.3s;
  cursor: auto;

  &:hover {
    -xpedu-transform: scale(1.1);
    -ms-transform: scale(1.1);
    transform: scale(1.1);
  }
`;

export const Title = styled.h2`
  color: #00b1f1;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 24px;
  text-align: center;
`;

export const ContTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 10px;
`;

export const ContInfo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;

  background-color: #fff;
  /* padding: 5px; */
`;

export const LabelInfo = styled.div`
  /* padding: 10px; */

  p {
    font-size: 12px;
    color: #3c6ab4;
    font-weight: 700;
    line-height: 0;
    letter-spacing: 0.5px;
    text-align: center;
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: center; */
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }
`;

export const Label = styled.div`
  font-size: 16px;
  margin-bottom: 5px;
  display: flex;
  align-items: baseline;
  img {
    width: 10px;
  }
`;

export const Valor = styled.div`
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 5px;
  margin-right: 5px;
  letter-spacing: 0.5px;
`;

export const Peso = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 500;
  font-size: 14px;
  opacity: 0.7;
  margin-bottom: 10px;
  margin-right: 5px;
  letter-spacing: 0.5px;

  small {
    font-size: 10px;
  }
`;
